<template lang="pug">
  .component-backoffice-category-list.row.column
    .row.column
      base-list(:component="component", :dataLoader="dataLoader", :showPerPageSelect="true")
</template>

<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import BaseList from './BaseList'


export default {
  name: 'VatList',
  components: {
    BaseList,
  },
  data: function () {
    return {
      component: require('src/components/backoffice/Vat.vue'),
    }
  },
  created() {
  },
  methods: {
    dataLoader(callback,page, resultsPerPage) {
      KeplerBackofficeSdk.vats.list(page, resultsPerPage).all((data) => {
        callback(data)
      })
    },

  },
}
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// VatList.vue?7f406de9